// extracted by mini-css-extract-plugin
module.exports = {"modal":"NcaaIdModal_modal__43S_Q","actions":"NcaaIdModal_actions__5rxPs","link":"NcaaIdModal_link__dDuOB","form":"NcaaIdModal_form__kvBdf"};